import { Pagination } from "#resources/api/enterprise-generated";
import {
	useGetEventOperationsByPlaceId,
	useRequestClosingOfEventOperation,
} from "#resources/hooks/integrations/place/query";
import constate from "constate";
import React from "react";

export const [FinancialFileProvider, useFinancialFileState] = constate(
	({ placeId }: { placeId: string }) => {
		const [currentEventOperationId, setCurrentEventOperationId] = React.useState<string>(
			"",
		);

		const [currentPagination, setCurrentPagination] = React.useState<Pagination>({
			currentPage: 0,
			perPage: 10,
		});

		const { data, isLoading } = useGetEventOperationsByPlaceId({
			request: {
				filters: {
					placeId,
				},
				pagination: {
					currentPage: currentPagination.currentPage,
					perPage: currentPagination.perPage,
				},
			},
		});

		const financialFileItems = data?.data;

		const {
			data: requestClosingOfEventOperationData,
		} = useRequestClosingOfEventOperation({
			id: currentEventOperationId,
		});

		const clearCurrentEventOperationId = React.useCallback(() => {
			setCurrentEventOperationId("");
		}, []);

		return {
			loading: isLoading,
			financialFileItems: financialFileItems ?? [],
			onChangePagination: setCurrentPagination,
			pagination: data?.pagination,
			requestClosingOfEventOperationData,
			currentEventOperationId,
			setCurrentEventOperationId,
			clearCurrentEventOperationId,
		};
	},
);
